import { Component, ViewChild, OnInit } from '@angular/core';
import { AddKriDialogBoxComponent } from './dialog/add-kri-dialog-box.component';
import { MatTable } from '@angular/material/table';
import { MatDialog } from '@angular/material/dialog';
import { first } from 'rxjs/operators';
import { Kri } from 'app/main/models/kri.model';
import { KriService } from 'app/main/services/kri.service';
import { MatIconModule } from '@angular/material/icon';
import { MatDrawer } from '@angular/material/sidenav';
import { FormGroup, FormBuilder } from '@angular/forms';
import { MatPaginator, PageEvent } from "@angular/material/paginator";

const ELEMENT_DATA: Kri[] = [];

@Component({
    selector   : 'mis-kris',
    templateUrl: './kri.component.html',
    styleUrls  : ['./kri.component.scss']
})
export class MisKriComponent
{
    titulo="Mis KRI";
    displayedColumns: string[] = ['activo','nombre','evaluacion','evaluacionActiva','riesgo','frecuencia','action'];
    dataSource = ELEMENT_DATA;
    filterForm: FormGroup;
    basicSlice = 10;
    elementCount = 0;

    @ViewChild(MatTable, {static: true}) table: MatTable<any>;

    constructor(public dialog: MatDialog,
                private _formBuilder: FormBuilder,
                private service: KriService) {}

      ngOnInit() {
        this.filterForm = this._formBuilder.group({});
        this.getElements(0);
      }
  
      onSubmit(): void {
        this.getElements(0);
      }
  
      getElements(page):void{
            
        var today = new Date();

        this.service.countMyKri(this.filterForm).subscribe(req => {
          this.elementCount = req.body;
        });

        this.service.getAllByUser(this.filterForm, page, this.basicSlice).pipe().subscribe(req => {
          this.dataSource = req.body.map( kri => {
            console.log(kri);
            return {
              id: kri.id,
              nombre: kri.nombre,
              riesgo: kri.riesgo,
              estructura: kri.estructura,
              nodo: kri.nodo,
              responsable: kri.responsable,
              fechaInicio: kri.fechaInicio,
              fechaFin: kri.fechaFin,
              frecuencia: kri.frecuencia,
              medicion: kri.medicion,
              evaluacion: kri.evaluacion,
              mediciones: kri.mediciones,
              tieneEditar: (kri.evaluacion!=null && kri.evaluacion.estado=='APROBADO' &&
              (new Date(kri.fechaInicio)<=today) && (new Date(kri.fechaFin) >=today)) ? true:false,
              estaAtrasado: kri.estaAtrasado
            };
          });
          this.dataSource.sort((a, b) => (a.nombre > b.nombre) ? 1 : -1);
        });
    }

    OnePageChange(event: PageEvent) {
      this.basicSlice = event.pageSize;
      this.getElements(event.pageIndex);
    }

    openDialog(action, obj): void {
      obj.action = action || 'View';
      const dialogRef = this.dialog.open(AddKriDialogBoxComponent, {
        width: '100%',
        data: obj,
        disableClose: true
      });

      /*
      dialogRef.afterClosed().subscribe(result => {

        if(result.dataSource!=null){
          this.dataSource = result.dataSource;
          this.dataSource.sort((a, b) => (a.nombre > b.nombre) ? 1 : -1);
        }
        this.table.renderRows();
      });*/
    }

}
